<main class="cd-main">
  <!-- HEADER -->
  <div class="cd-header-row">
    <div>
      <h1 class="cd-title">Add User</h1>
      <p class="cd-subtitle">Manually Add User</p>
    </div>
    <div class="header-actions">
      <button
        mat-flat-button
        color="primary"
        class="cd-submit-btn"
        data-testid="issue-reports-send-report"
        [disabled]="form.invalid"
        (click)="addUser()"
        aria-label="Send report"
      >
        Add User
      </button>
    </div>
  </div>

  <form [formGroup]="form" aria-label="New report form">
    <div class="ce-main">
      <mat-card class="ce-card" appearance="outlined">
        <mat-card-content>
          <h2 class="ce-section-title">Report details</h2>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>First Name</mat-label>
            <input
              matInput
              formControlName="first_name"
              placeholder="First Name"
              data-testid="issue-reports-title"
              aria-label="First Name"
            />
            <mat-error>First Name is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>Last Name</mat-label>
            <input
              matInput
              formControlName="last_name"
              placeholder="Last Name"
              data-testid="issue-reports-title"
              aria-label="Last Name"
            />
            <mat-error>Last Name is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>Email</mat-label>
            <input
              matInput
              formControlName="email"
              placeholder="Email"
              data-testid="issue-reports-title"
              aria-label="Email"
            />
            <mat-error>Email is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>User Type</mat-label>
            <mat-select formControlName="user_type" aria-label="Select school">
              @for (c of types; track c) {
                <mat-option [value]="c">{{ c }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (schools.length > 0) {
            <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
              <mat-label>School</mat-label>
              <mat-select formControlName="school" aria-label="Select school">
                <mat-option [value]="null">None</mat-option>
                @for (c of schools; track c.id) {
                  <mat-option [value]="c.id">{{ c.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (districts.length > 0) {
            <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
              <mat-label>District</mat-label>
              <mat-select formControlName="district" aria-label="Select district">
                <mat-option [value]="null">None</mat-option>
                @for (c of districts; track c.id) {
                  <mat-option [value]="c.id">{{ c.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </form>
</main>
